import React from "react";
import {
  Newspaper,
  Bell,
  Signal,
  Calendar,
  Filter,
  Brain,
  Activity,
  Bookmark,
} from "lucide-react";

const marketTools = [
  {
    icon: <Newspaper />,
    title: "Market News",
    desc: "Real-time global financial news curated for traders",
  },
  {
    icon: <Bell />,
    title: "Price Alerts",
    desc: "Instant alerts for price, volatility & key levels",
  },
  {
    icon: <Signal />,
    title: "Trading Signals",
    desc: "Verified signals with transparent performance",
  },
  {
    icon: <Calendar />,
    title: "Economic Calendar",
    desc: "Track high-impact global economic events",
  },
  {
    icon: <Filter />,
    title: "Market Screener",
    desc: "Filter opportunities across markets & assets",
  },
  {
    icon: <Brain />,
    title: "AI Market Insights",
    desc: "AI-powered summaries, bias & trend detection",
  },
  {
    icon: <Activity />,
    title: "Market Sentiment",
    desc: "Understand crowd and institutional sentiment",
  },
  {
    icon: <Bookmark />,
    title: "Smart Watchlists",
    desc: "Create, follow & share custom market watchlists",
  },
];

export default function StayConnectedMarkets() {
  return (
    <section className="w-full bg-[#0B0F19] py-24">
      <div className="mx-auto max-w-6xl px-4">
        {/* Header */}
        <div className="mb-12 text-left">
          <h2 className="text-2xl font-bold text-white sm:text-3xl lg:text-3xl">
            Stay Connected with the{" "}
            <span className="text-blue-600">Markets</span>
          </h2>
          <p className="mt-1 text-sm text-gray-400 sm:text-base">
            Monitor, react, and act — all from one platform
          </p>
        </div>

        {/* Dark Container */}
        <div className="rounded-3xl border border-white/5 bg-[#0B0F19] px-6 py-12 shadow-[0_20px_60px_rgba(0,0,0,0.25)]">
          <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
            {marketTools.map((item, idx) => (
              <div
                key={idx}
                className="rounded-3xl border border-white/10 bg-gradient-to-br from-[#12172A] to-[#0B0F19] p-8 transition-all duration-300 hover:-translate-y-1 hover:border-blue-500/40"
              >
                <div className="flex h-12 w-12 items-center justify-center rounded-full bg-blue-600 text-white">
                  {item.icon}
                </div>

                <h3 className="mt-5 text-lg font-semibold text-white">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm text-gray-400">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
